import ReactDOMServer from 'react-dom/server';
import {ShapeTooltip} from "../ShapeItem";

function ReactProjectInfo({project}) {
    return (
        <div style={{color: project.color}}>
            {project.title} <br/>
            {project.plan} <br/>
            {project.river}
        </div>
    )
}

export default function MapProjectInfo(L, type, map) {
    let container = null

    const bottomLeft = L.control({
        position: 'bottomleft'
    });

    const projectInfoEvent = (e) => {
        const project = e.detail;
        if(project) {
            container.innerHTML = ReactDOMServer.renderToString(
                <ReactProjectInfo project={project[type]} />
            )
        }
    }

    bottomLeft.onAdd = function (map) {
        container = L.DomUtil.create('div', `project-info-${type}`);
        window.addEventListener('change-project-info', projectInfoEvent)
        container.innerHTML = '';
        return container;
    };

    bottomLeft.onRemove = function (map) {
        window.removeEventListener('change-project-info', projectInfoEvent)
    }

    bottomLeft.addTo(map);
}